var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.166,
    height: 54.682,
    viewBox: "0 0 54.166 54.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "loading-3-quarters",
    d: "M27.086,54.172A27.057,27.057,0,0,1,0,27.086a1.9,1.9,0,1,1,3.809,0,23.273,23.273,0,0,0,39.74,16.458A23.268,23.268,0,0,0,27.086,3.809a1.9,1.9,0,1,1,0-3.809A27.091,27.091,0,0,1,37.629,52.04,26.825,26.825,0,0,1,27.086,54.172Z",
    transform: "translate(0 0.511)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "loading",
    d: "M27.227,29.141a1.913,1.913,0,0,1-1.914-1.914,23.22,23.22,0,0,0-1.84-9.109,23.424,23.424,0,0,0-5.015-7.439A23.308,23.308,0,0,0,1.914,3.829,1.914,1.914,0,0,1,1.914,0a26.964,26.964,0,0,1,10.6,2.143,27.034,27.034,0,0,1,8.652,5.834A27.181,27.181,0,0,1,27,16.629a27.055,27.055,0,0,1,2.138,10.6A1.905,1.905,0,0,1,27.227,29.141Z",
    transform: "matrix(0.017, -1, 1, 0.017, 0, 29.131)",
    fill: "#758ca1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadMore);
export default __webpack_public_path__ + "static/media/load-more.3b29363c.svg";
export { ForwardRef as ReactComponent };